<template>
  <div class="new-layout">
    <div class="action-bar" v-if="isMobile && showOverlayMobile">
      <span class="action-header-txt">
        <img
          class="icon-exclamation"
          src="../../assets/img/icons/exclamation-triangle-fill.svg"
        />
        Trocou a placa do seu veículo para o padrão
        <span class="special-font">Mercosul</span>? Não esqueça de atualizar os
        dados veiculares da sua TAG.
        <span class="special-font">Evite multas!</span>
      </span>
      <span class="close-alert special-font" @click="fecharActionBar"
        ><img class="closeIcon" src="../../assets/img/icons/close.svg"
      /></span>
    </div>
    <div
      class="container container-companies"
      v-if="companies"
      style="z-index: 9997"
    >
      <div class="dropdown drop-full">
        <button
          class="form-control dropdown-toggle btn-dropdown drop-dark drop-word-wrap"
          type="button"
          id="empresas"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <span class="selected">{{ currentUser.company.companyName }} </span> -
          <span v-mask-cpf-cnpj>{{ currentUser.taxIdNumber }}</span>
          <i class="icon-arrow-down-dropdown"></i>
        </button>
        <ul class="dropdown-menu" aria-labelledby="empresas">
          <li v-for="(company, index) in companies" :key="index">
            <a
              :class="{ active: company.moveMaisId == currentUser.moveMaisId }"
              @click="changeUser(company.moveMaisId)"
            >
              <span class="word-wrap">{{ company.companyName }} </span> -
              <span v-mask-cpf-cnpj> {{ company.taxIdNumber }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- v-on:scroll="handleScroll" -->
    <div
      class="tabs-section hidden-print"
      :class="{ fixed: scrolling }"
      id="tabs-section"
      style="z-index: 9997"
    >
      <div class="action-bar" v-if="showOverlay && !isMobile">
        <span class="action-header-txt">
          <img
            class="icon-exclamation"
            src="../../assets/img/icons/exclamation-triangle-fill.svg"
          />
          Trocou a placa do seu veículo para o padrão
          <span class="special-font">Mercosul</span>? Não esqueça de atualizar
          os dados veiculares da sua TAG.
          <span class="special-font">Evite multas!</span>
        </span>
        <span class="close-alert special-font" @click="fecharActionBar"
          ><img class="closeIcon" src="../../assets/img/icons/close.svg"
        /></span>
      </div>
      <div class="container">
        <router-link :to="{ name: 'home' }" class="tab-item">
          <img
            class="logo-img"
            src="../../../static/Logo_Move_Mais_Vertical_2026.svg"
            alt="Logo Move Mais TAG"
            width="130"
            v-if="!scrolling"
          />
          <img
            class="logo-img"
            src="../../../static/Logo_Move_Mais_Vertical_Branco_2026.svg"
            alt="Logo Move Mais TAG"
            width="130"
            v-else
          />
        </router-link>
        <ul class="nav nav-tabs">
          <!-- <li role="presentation">
          </li> -->
          <li role="presentation">
            <router-link :to="{ name: 'plans' }" class="tab-item">
              <i class="icon-padnote"></i>
              <span>Planos</span>
            </router-link>
          </li>
          <li role="presentation">
            <router-link :to="{ name: 'requests' }" class="tab-item">
              <i class="icon-bell"></i>
              <span>Pedidos</span>
            </router-link>
          </li>
          <li role="presentation">
            <router-link :to="{ name: 'tag-activate' }" class="tab-item">
              <i class="icon-active-tag"></i>
              <span>Ativar TAG</span>
            </router-link>
          </li>
          <li role="presentation">
            <router-link :to="{ name: 'routing' }" class="tab-item">
              <i class="icon-routing"></i>
              <span>Viagem</span>
            </router-link>
          </li>
          <li role="presentation" v-if="false">
            <router-link :to="{ name: 'routing' }" class="tab-item">
              <i class="icon-key"></i>
              <span>Rotas</span>
            </router-link>
          </li>
          <li role="presentation" v-if="refund">
            <router-link :to="{ name: 'refund' }" class="tab-item">
              <i class="icon-road"></i>
              <span>Contestação</span>
            </router-link>
          </li>
          <!-- <li role="presentation">
            <a href="#" class="tab-item link-disabled">
              <i class="icon-share"></i>
              <span>Indique um amigo</span>
            </a>
          </li> -->

          <!--<li role="presentation">
            <router-link :to="{name: 'rntrc-vinculation'}" class="tab-item">
              <i class="icon-truck"></i>
              <span>RNTRC</span>
            </router-link>
          </li>-->

          <li role="presentation">
            <router-link :to="{ name: 'profile' }" class="tab-item">
              <i class="icon-my-data"></i>
              <span>Meus dados</span>
            </router-link>
          </li>
          <li role="presentation" v-if="is2FA">
            <router-link
              :to="{ name: 'password-change-confirmation' }"
              class="tab-item"
            >
              <i class="icon-key"></i>
              <span>Alterar senha</span>
            </router-link>
          </li>
          <li role="presentation" v-if="!is2FA">
            <router-link :to="{ name: 'password-change' }" class="tab-item">
              <i class="icon-key"></i>
              <span>Alterar senha</span>
            </router-link>
          </li>

          <li role="presentation" class="pull-right">
            <a href="javascript:;" @click="logout" class="tab-item">
              <i class="icon-logout"></i>
              <span>Sair</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div
      class="tabs-section hidden-print mob"
      :class="{ fixed: scrolling }"
      id="tabs-section"
      style="z-index: 9997"
    >
      <div class="container">
        <router-link :to="{ name: 'home' }" class="tab-item">
          <img
            class="logo-img"
            src="../../../static/Logo_Move_Mais_Horizontal_2026.svg"
            alt="Logo Move Mais TAG"
            width="210"
          />
        </router-link>
        <ul class="nav nav-tabs">
          <li role="presentation" class="pull-right">
            <a href="javascript:;" @click="logout" class="tab-item">
              <i class="icon-logout"></i>
              <span>Sair</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

    <router-view :class="{ 'fix-footer': fixFooter }"></router-view>

    <div class="footer-mobile hidden-print" v-if="!fixFooter">
      <router-link :to="{ name: 'plans' }">
        <div class="footer-mobile-link word-wrap">
          <i class="icon-padnote"></i>
          Planos
        </div>
      </router-link>
      <router-link :to="{ name: 'requests' }">
        <div class="footer-mobile-link word-wrap">
          <i class="icon-bell"></i>
          Pedidos
        </div>
      </router-link>
      <router-link :to="{ name: 'tag-activate' }">
        <div class="footer-mobile-link word-wrap">
          <i class="icon-active-tag"></i>
          Ativar TAG
        </div>
      </router-link>
      <router-link :to="{ name: 'routing' }">
        <div class="footer-mobile-link word-wrap">
          <i class="icon-routing"></i>
          Viagem
        </div>
      </router-link>
      <div class="dropup footer-mobile-link">
        <a
          class="dropdown-toggle"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="icon-ellipsis"></i>
          Mais
        </a>
        <ul class="dropdown-menu dropdown-menu-right">
          <!--<li>
              <router-link :to="{name: 'rntrc-vinculation'}">
                <i class="icon-truck icon-footer-dropup"></i>
                RNTRC
              </router-link>
            </li>-->
          <li role="separator" class="divider"></li>
          <li>
            <router-link :to="{ name: 'notification' }">
              <i class="icon-mail icon-footer-dropup"></i>
              Notificações
            </router-link>
          </li>
          <li role="separator" class="divider"></li>
          <li>
            <router-link :to="{ name: 'profile' }">
              <i class="icon-my-data icon-footer-dropup"></i>
              Meus Dados
            </router-link>
          </li>
          <li role="separator" class="divider"></li>
          <li>
            <router-link :to="{ name: 'password-change' }">
              <i class="icon-key icon-footer-dropup"></i>
              Alterar senha
            </router-link>
          </li>
          <li role="separator" class="divider"></li>
          <li>
            <a href="javascript:;" @click="logout">
              <i class="icon-logout icon-footer-dropup"></i>
              Sair
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom-wrap"></div>

    <footer class="footer footer-inside">
      <div class="container">
        <div class="row">
          <div class="col-sm-8 col-md-8">
            <div class="sac-icon-circle">
              <i class="icon-help-desk sac-icon-fix"></i>
            </div>
            <div class="sac-text">
              <p class="bold">central de relacionamento</p>
              <p>
                Capitais e regiões metropolitanas
                <span class="sac-phone-number">4000 2901</span>
              </p>
              <p>
                Demais localidades
                <span class="sac-phone-number">0800 777 1022</span>
              </p>
              <p>E-mail: <span>relacionamento@movemais.com</span></p>
            </div>
          </div>
          <div class="col-sm-4 col-md-4">
            <div class="seals">
              <!-- <img src="../../../static/CertificadoRA1000_site.png" alt="Certificado RA 1000"> -->
              <img
                src="../../assets/img/sectigo_trust_seal_sm_2x.png"
                alt="Sectigo Secure Seal"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<style scoped>
.action-bar {
  display: flex;
  width: 100%;
  padding: 16px;
  justify-content: center;
  /* align-items: flex-start; */
  border: 1px solid var(--indigo-300, #a370f7);
  background: var(--primary-light, #ebe5fc);
  color: var(--indigo-800, #290661);
  /* text-align: center; */
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.icon-exclamation {
  width: 16px;
  height: 16px;
  margin-top: -2px;
}

.new-layout {
  margin-top: 51px;
}

.special-font {
  color: var(--indigo-800, #290661);
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.close-alert {
  margin-left: auto;
  cursor: pointer;
}

.action-header-txt {
  margin-left: auto;
}

.closeIcon {
  width: 16px;
  height: 16px;
  margin-top: 2px;
}

.logo-img {
  vertical-align: middle;
  margin-top: 0;
}

#tabs-section > .container {
  display: flex;
  align-items: center;
}
</style>
<script>
import auth from "../../services/auth";
import account from "../../services/account";
import { EventBus } from "../../event-bus";
import refund from "../../services/refund-service";

export default {
  data() {
    return {
      name: undefined,
      companies: undefined,
      currentUser: auth.currentUser,
      parentUser: auth.parentUser,
      mainMenu: true,
      loading: undefined,
      fixFooter: true,
      filter: {
        taxPayerIdNumber: auth.currentUser.taxIdNumber,
      },
      refund: false,
      scrolling: false,
      is2FA: undefined,
      showOverlay: true,
      showOverlayMobile: true,
      isMobile: false,
    };
  },

  beforeRouteUpdate(to, from, next) {
    // Verificar se a palavra "meus-planos" está presente na nova URL
    if (to.fullPath.includes("meus-planos")) {
      this.showOverlayMobile = true;
      this.showOverlay = true;

      const newLayout = document.querySelector(".new-layout");
      if (newLayout) {
        newLayout.style.marginTop = "51";
      }
    } else {
      this.showOverlayMobile = false;
      this.fecharActionBar();
    }

    next();
  },

  computed: {
    isEmbarcador() {
      return this.$store.state.contract.hasPlanEmbarcador;
    },
  },

  methods: {
    fecharActionBar() {
      this.showOverlay = false;
      this.showOverlayMobile = false;

      this.$nextTick(() => {
        this.removerMarginTop();
      });
    },

    removerMarginTop() {
      const newLayout = document.querySelector(".new-layout");
      if (newLayout) {
        newLayout.style.marginTop = "0";
      }
    },
    logout() {
      auth.logout().then(() => this.$router.push("/login"));
    },
    changeUser(moveMaisId) {
      auth.changeCurrentUser(moveMaisId);
      this.$router.push({ name: "plans", query: { moveMaisId: moveMaisId } });

      setTimeout(function () {
        window.location.reload(1);
      }, 1000); // 2 segundos
    },
    getChildAccounts(moveMaisId) {
      if (this.$route.name == "adhesion") {
        return;
      }
      this.loading = account
        .getListChildAccount(auth.parentUser.moveMaisId)
        .then((res) => {
          res.unshift({
            moveMaisId: auth.parentUser.moveMaisId,
            taxIdNumber: auth.parentUser.taxIdNumber,
            companyName: auth.parentUser.company.companyName,
            companyTradeName: auth.parentUser.company.companyTradeName,
          });
          this.companies = res;
        })
        .catch((err) => {});
    },
    handleScroll() {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollPosition > 84) {
        this.scrolling = true;
      } else {
        this.scrolling = false;
      }
    },
  },

  created() {
    let updateUser = (user) => {
      this.currentUser = user;
    };

    if (this.currentUser.flag2FA == "Y") {
      this.is2FA = true;
    } else {
      this.is2FA = false;
    }

    auth.$on("userChanged", (user) => {
      updateUser(user);
    });

    auth.$on("parentUserChanged", (user) => {
      this.parentUser = user;
      this.companies = undefined;
      if (auth.parentUser) this.getChildAccounts(user.moveMaisId);
    });

    if (auth.parentUser) this.getChildAccounts(auth.parentUser.moveMaisId);

    EventBus.$on("loading", (l) => {
      this.loading = l;
    });
  },
  mounted() {
    document.addEventListener("scroll", this.handleScroll);

    let vm = this;
    setTimeout(function () {
      vm.fixFooter = false;
      vm.$forceUpdate();
    }, 2000);
    this.loading = refund.isRefundPassage(this.filter).then((resp) => {
      if (resp.refund == 1) {
        this.refund = true;
      }
    });

    // saber se está em desktop ou mobile.
    if (window.innerWidth <= 769) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    // evento disparado toda vez que a tela muda de tamanho
    window.addEventListener("resize", () =>
      window.innerWidth <= 769
        ? (this.isMobile = true)
        : (this.isMobile = false)
    );
    // debugger;

    // if (window.location.href.includes("meus-planos")) {
    //   debugger;
    //   this.showOverlay = true;
    // }
  },
  beforeDestroy() {
    auth.$off("userChanged");
    auth.$off("parentUserChanged");
  },
};
</script>



// WEBPACK FOOTER //
// home-account.vue?f861489a